import * as UtilBase from './mediaDescription-util-base'
export default { ...UtilBase }
